/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuardService } from "../../shared/services/auth-guard.service";
import { HomeComponent} from "../home/home.component";
import { viagensRoute } from "../../viagens/shared/data.service";
import { viagensVisitantesRoutes } from "../../viagens/viagens-routing.module";
import { ViagensComponent } from "../../viagens/viagens.component";
import { recursosHumanosRoute } from "../../recursos-humanos/shared/data.service";
import { RecursosHumanosComponent } from "../../recursos-humanos/recursos-humanos.component";
import { usuariosRoute } from "../../recursos-humanos/usuarios/shared/data.service";
import { UsuariosComponent } from "../../recursos-humanos/usuarios/usuarios.component";
import { usuariosRoutes } from "../../recursos-humanos/usuarios/usuarios-routing.module";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class VisitantesRoutingModule {}

export const visitantesRoutes: any[] = [
    {
        path: '',
        component: HomeComponent
    },{
        path: viagensRoute,
        component: ViagensComponent,
        canActivateChild: [AuthGuardService],
        children: viagensVisitantesRoutes
    },{
        path: recursosHumanosRoute,
        component: RecursosHumanosComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: usuariosRoute,
                component: UsuariosComponent,
                canActivate: [AuthGuardService],
                children: usuariosRoutes
            }
        ]
    },
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/visitante/visitantes-routing.module.ts
 **/